import {
  BookMarkedIcon,
  FlaskConicalIcon,
  HistoryIcon,
  InfoIcon,
  LightbulbIcon,
  MessageCircleIcon,
  NetworkIcon,
  PlugIcon,
  SettingsIcon,
} from 'lucide-react';
import { type LucideIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { CommandGroup } from '@/components/ui/command';
import { selectAccountSlug } from '@/redux/session/selectors';

import { CommandLinkItem } from '../CommandLinkItem';
import { type SelectedAgent } from '../types';

type AgentSubPagesGroupProps = {
  agent: SelectedAgent;
  onSelect: (path: string, label: string) => void;
};

const SUB_PAGES: { i18nKey: string; suffix: string; icon: LucideIcon }[] = [
  { i18nKey: 'ai_agents.navigation.overview', suffix: '/overview', icon: InfoIcon },
  { i18nKey: 'ai_agents.navigation.guidelines', suffix: '/guidelines', icon: BookMarkedIcon },
  { i18nKey: 'ai_agents.navigation.workflows', suffix: '/workflows/dialogs', icon: NetworkIcon },
  { i18nKey: 'common.logs', suffix: '/logs', icon: MessageCircleIcon },
  { i18nKey: 'common.versions', suffix: '/versions', icon: HistoryIcon },
  { i18nKey: 'common.settings', suffix: '/settings', icon: SettingsIcon },
  { i18nKey: 'common.mcps', suffix: '/mcps', icon: PlugIcon },
  { i18nKey: 'common.insights', suffix: '/insights', icon: LightbulbIcon },
  { i18nKey: 'simulations.title', suffix: '/simulations', icon: FlaskConicalIcon },
];

export const AgentSubPagesGroup = ({ agent, onSelect }: AgentSubPagesGroupProps) => {
  const { t } = useTranslation();
  const slug = useSelector(selectAccountSlug);

  return (
    <CommandGroup heading={agent.name}>
      {SUB_PAGES.map((page) => {
        const label = t(page.i18nKey);
        const path = `/ai-agents/${agent.brain_id}${page.suffix}`;
        const Icon = page.icon;
        return (
          <CommandLinkItem
            key={page.suffix}
            value={`agent-subpage-${page.suffix}`}
            href={slug ? `/${slug}${path}` : '#'}
            onSelect={() => onSelect(path, `${agent.name} > ${label}`)}
            keywords={[label]}
          >
            <Icon />
            <span>{label}</span>
          </CommandLinkItem>
        );
      })}
    </CommandGroup>
  );
};
